import React from 'react';
import { Bug, Sparkles, ListTodo, AlertCircle, User } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent } from '@/components/ui/card';

const BacklogView = ({ solicitudes, loading, onViewDetail, getTipoIcon, getTipoLabel, getPrioridadColor, getEstadoColor, getEstadoLabel }) => {
  if (loading) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground">Cargando solicitudes...</p>
      </div>
    );
  }

  if (solicitudes.length === 0) {
    return (
      <Card>
        <CardContent className="py-12 text-center">
          <AlertCircle className="h-12 w-12 mx-auto text-muted-foreground mb-4" />
          <p className="text-muted-foreground">No se encontraron solicitudes</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-4">
      {solicitudes.map((solicitud) => (
        <Card
          key={solicitud._id}
          className="cursor-pointer hover:shadow-md transition-shadow"
          onClick={() => onViewDetail(solicitud)}
        >
          <CardContent className="p-6">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-2">
                  {solicitud.consecutivo && (
                    <Badge variant="outline" className="font-mono text-xs">
                      {solicitud.consecutivo}
                    </Badge>
                  )}
                  {getTipoIcon(solicitud.tipo)}
                  <h3 className="text-lg font-semibold">{solicitud.titulo}</h3>
                </div>
                <p className="text-sm text-muted-foreground mb-3 line-clamp-2">
                  {solicitud.descripcion}
                </p>
                <div className="flex flex-wrap gap-2">
                  <Badge variant={getPrioridadColor(solicitud.prioridad)}>
                    {solicitud.prioridad}
                  </Badge>
                  <Badge className={getEstadoColor(solicitud.estado)}>
                    {getEstadoLabel(solicitud.estado)}
                  </Badge>
                  <Badge variant="outline">{getTipoLabel(solicitud.tipo)}</Badge>
                  {solicitud.modulo && (
                    <Badge variant="secondary">{solicitud.modulo}</Badge>
                  )}
                </div>
              </div>
              <div className="text-right text-sm ml-4 space-y-2">
                <p className="text-muted-foreground">Creado por: {solicitud.creadoPor?.nombre}</p>
                <p className="text-muted-foreground">{new Date(solicitud.fechaCreacion).toLocaleDateString()}</p>
                {solicitud.asignadoA ? (
                  <div className="mt-2 inline-flex items-center gap-1 bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 px-3 py-1 rounded-full font-medium">
                    <User className="h-3 w-3" />
                    <span>{solicitud.asignadoA.nombre}</span>
                  </div>
                ) : (
                  <div className="mt-2 inline-flex items-center gap-1 bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 px-3 py-1 rounded-full text-xs">
                    Sin asignar
                  </div>
                )}
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default BacklogView;
